__turbopack_context__.v({
  "arcContainer": "ReportRating-module__U2-02W__arcContainer",
  "baseArc": "ReportRating-module__U2-02W__baseArc",
  "defaultContent": "ReportRating-module__U2-02W__defaultContent",
  "h5Icon": "ReportRating-module__U2-02W__h5Icon",
  "hoverArea": "ReportRating-module__U2-02W__hoverArea",
  "hoverContent": "ReportRating-module__U2-02W__hoverContent",
  "nullArea": "ReportRating-module__U2-02W__nullArea",
  "nullContent": "ReportRating-module__U2-02W__nullContent",
  "nullText": "ReportRating-module__U2-02W__nullText",
  "ratingA": "ReportRating-module__U2-02W__ratingA",
  "ratingAMinus": "ReportRating-module__U2-02W__ratingAMinus",
  "ratingAPlus": "ReportRating-module__U2-02W__ratingAPlus",
  "ratingArc": "ReportRating-module__U2-02W__ratingArc",
  "ratingB": "ReportRating-module__U2-02W__ratingB",
  "ratingBMinus": "ReportRating-module__U2-02W__ratingBMinus",
  "ratingBPlus": "ReportRating-module__U2-02W__ratingBPlus",
  "ratingC": "ReportRating-module__U2-02W__ratingC",
  "ratingCMinus": "ReportRating-module__U2-02W__ratingCMinus",
  "ratingCPlus": "ReportRating-module__U2-02W__ratingCPlus",
  "ratingD": "ReportRating-module__U2-02W__ratingD",
  "ratingDMinus": "ReportRating-module__U2-02W__ratingDMinus",
  "ratingDPlus": "ReportRating-module__U2-02W__ratingDPlus",
  "text": "ReportRating-module__U2-02W__text",
  "whiteArc": "ReportRating-module__U2-02W__whiteArc",
});
